import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const UserActivate = () => {
  const { usuario } = useParams(); // Recibe el string base64
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [nombreCompleto, setNombreCompleto] = useState("El usaurio");

  useEffect(() => {
    try {
      // 1. Decodificamos el string base64
      const decodedUsuario = atob(usuario); // Base64 → JSON string
      const parsedLevel1 = JSON.parse(decodedUsuario); // Primer parse (devuelve un string JSON dentro de 'body')

      // 2. Si viene como string en la propiedad 'body', se parsea de nuevo
      let parsedLevel2 = parsedLevel1;
      if (typeof parsedLevel1.body === 'string') {
        const bodyData = JSON.parse(parsedLevel1.body);
        parsedLevel2 = bodyData?.data || {};
      }

      // 3. Construimos el nombre completo
      const fullName = [
        parsedLevel2.primerNombre,
        parsedLevel2.segundoNombre,
        parsedLevel2.primerApellido,
        parsedLevel2.segundoApellido
      ].filter(Boolean).join(' ');

      setNombreCompleto(fullName || "Usuario activado");
    } catch (error) {
      console.error("Error al decodificar o parsear usuario:", error);
      setNombreCompleto("Usuario activado");
    }

    setShowModal(true);
  }, [usuario]);

  const handleAccept = () => {
    setShowModal(false);
    navigate('/login'); // Redirige a login
  };

  return (
    <>
      {showModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2>¡Usuario Activado!</h2>
            <p>
              <strong>{nombreCompleto}</strong> ha sido activado correctamente.
            </p>
            <button onClick={handleAccept} style={styles.button}>Aceptar</button>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center',
    zIndex: 9999
  },
  modal: {
    backgroundColor: '#fff', padding: '2rem', borderRadius: '10px',
    width: '90%', maxWidth: '400px', textAlign: 'center'
  },
  button: {
    marginTop: '1rem', padding: '0.5rem 1rem',
    backgroundColor: '#2196F3', color: '#fff', border: 'none',
    borderRadius: '5px', cursor: 'pointer'
  }
};

export default UserActivate;
